import { render, staticRenderFns } from "./BackPress.vue?vue&type=template&id=28d8e791&scoped=true&"
import script from "./BackPress.vue?vue&type=script&lang=ts&"
export * from "./BackPress.vue?vue&type=script&lang=ts&"
import style0 from "./BackPress.vue?vue&type=style&index=0&id=28d8e791&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8e791",
  null
  
)

export default component.exports